query ($id: UUID!, $sportLogicTemplateIds: [UUID!]) {
  sportTemplate: sportTemplateBySportTemplateId(sportTemplateId: $id) {
    marketConfigurations: marketConfigurationsBySportTemplateId(
      filter: {sportsLogicTemplateId: {in: $sportLogicTemplateIds}}
    ) {
      nodes {
        sportTemplateId
        enabled
        sportLogicTemplate: sportLogicTemplateBySportsLogicTemplateId {
          sportLogicTemplateId
        }
      }
    }
  }
}
